import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import Button from '../../components/ui/Button';
import StudentSignupForm from './components/StudentSignupForm';
import { registerStudent } from '../../services/registerService';
import IdUploadStep from '../Quiz/components/verification/IdUploadStep';
import { useNavigate } from 'react-router';
import { useAuth } from '../../contexts/authContext';
import { toast } from 'sonner';
import AlertBox from '../../components/ui/AlertBox';
import { useRedirectParam } from '../../hooks/useRedirectParam';

function StudentSignupPage() {
  let navigate = useNavigate();
  const { consumeRedirect } = useRedirectParam();
  let { register, handleSubmit, watch, setError, formState: { errors, isSubmitting } } = useForm();
  const { user, setUser, setProfile } = useAuth();
  const [pageError, setPageError] = useState('');
  const [signupStep, setSignupStep] = useState('details'); // 'details' or 'upload_id'

  const onSubmit = async (data) => {
    try {
      // Build dataToSend just like in LecturerSignupPage
      let dataToSend = {
        ...(data.university !== 'other' ? { university: data.university } : {}),
        ...(data?.other_university ? { other_university: data.other_university } : {}),
        ...(data.department !== 'other' ? { department: data.department } : {}),
        ...(data?.other_department ? { other_department: data.other_department } : {}),
        mat_no: data.mat_no,
      };

      console.log(dataToSend)

      const response = await registerStudent(dataToSend);

      console.log('Registration successful:', response);

      // The registerStudent endpoint returns only the profile (no user field).
      // Guard against wiping auth state with undefined.
      if (response.user) {
        setUser(response.user);
      } else {
        // Mark profile complete on the existing user so ProtectedRoute lets us through
        setUser((prev) => prev ? { ...prev, is_profile_complete: true, user_type: 'student' } : prev);
      }
      setProfile(response);
      toast.success('Successfully completed profile details');
      setSignupStep('upload_id');
    } catch (error) {
      console.error('Registration failed:', error);
      if (error && typeof error === 'object') {
        if (error.detail) {
          setPageError(error.detail);
        } else {
          Object.keys(error).forEach((field) => {
            const getErrorMessage = (val) => Array.isArray(val) ? val[0] : val;

            if (field === 'non_field_errors') {
              setPageError(getErrorMessage(error[field]));
            } else if (field === 'user' && error.user && typeof error.user === 'object') {
              Object.keys(error.user).forEach((userField) => {
                setError(userField, { type: 'server', message: getErrorMessage(error.user[userField]) });
              });
            } else {
              setError(field, { type: 'server', message: getErrorMessage(error[field]) });
            }
          });
        }
      } else {
        setPageError('An unexpected error occurred during signup.');
      }
    }
  };


  return (
    <div className='bg-base-200 py-12 px-4 sm:px-6 lg:px-8'>
      <div className='max-w-2xl mx-auto'>
        <div className="text-center space-y-4 mb-8">
          <div className="flex items-center justify-center gap-2 text-xl font-medium">
            <span>Hey,</span>
            <span className="font-bold">{user.first_name}</span>
            <span className="animate-wave text-3xl">👋</span>
          </div>

          <h1 className="text-4xl font-extrabold tracking-tight">
            Complete Your{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-pink-500 to-orange-500">
              Student
            </span>{" "}
            Profile
          </h1>
        </div>
        <div className="bg-base-100 shadow-xl rounded-box p-8">
          {signupStep === 'details' ? (
            <form onSubmit={handleSubmit(onSubmit)}>
              <AlertBox message={pageError} type='error' />
              <div className="grid grid-cols-1 gap-6">
                <StudentSignupForm
                  errors={errors}
                  register={register}
                  watch={watch}
                />
              </div>
              <Button
                className='w-full mt-4'
                isLoading={isSubmitting}
              >
                Create Account
              </Button>
            </form>
          ) : (
            <div className="space-y-4">
              <div className="text-center mb-6 space-y-2 animate-fade-in">
                <h2 className="text-2xl font-bold tracking-tight text-gray-800">Upload Your Student ID</h2>
                <p className="text-sm text-gray-500 max-w-md mx-auto">
                  Your profile details are saved successfully! You can now upload your student ID card.
                  This is optional, but required to take restricted exam quizzes.
                </p>
              </div>
              <IdUploadStep
                onNext={() => {
                  toast.success('Student ID uploaded successfully.');
                  const storedRedirect = consumeRedirect();
                  if (storedRedirect) {
                    navigate(storedRedirect);
                  } else {
                    navigate('/student/dashboard');
                  }
                }}
                onCancel={() => {
                  toast.info('ID upload skipped. You can upload it later in Account Settings.');
                  const storedRedirect = consumeRedirect();
                  if (storedRedirect) {
                    navigate(storedRedirect);
                  } else {
                    navigate('/student/dashboard');
                  }
                }}
                cancelText="Skip for Now"
                allowWebcam={false}
                submitText="Upload ID"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default StudentSignupPage